import { Component, OnInit, Input, Output, EventEmitter, OnChanges, SimpleChanges } from '@angular/core';

export const Colors = Object.freeze({
	COLOR_PRIMARY: 'swal2-confirm btn btn-next m-btn m-btn--custom',
	COLOR_PRIMARY_OUTLINE: 'swal2-confirm btn btn-secondary m-btn m-btn--custom',
	DEFAULT: 'swal2-confirm btn btn-success m-btn m-btn--custom',
});
export interface SweetAlertOptions {
	one: string;
	two: string;
	text: string;
	textClass?: string;
	text1?: string;
	text1Class?: string;
}
@Component({
	selector: 'app-display-result',
	templateUrl: './display-result.component.html',
	styleUrls: ['./display-result.component.css']
})
export class DisplayResultComponent implements OnInit, OnChanges {
	@Input() message: SweetAlertOptions;
	@Output() responseMessage = new EventEmitter<any>();
	constructor() { }

	ngOnChanges(changes: SimpleChanges){
		if (changes.message){
			console.log('messages', this.message);

		}
	}

	ngOnInit() {
	}

	continue(message?: any) {
		this.responseMessage.emit(message ? message : 'ok');
	}

}

